<template>
  <div class="loading">
    <div class="loading-content">
      <img width="24" height="24" src="./loading.gif">
      <p class="desc">{{ displayTitle }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loading',
    data() {
      return {
        customTitle: null
      }
    },
    computed: {
      displayTitle() {
        return this.customTitle != null && this.customTitle !== ''
          ? this.customTitle
          : this.$t('home.loading')
      }
    },
    methods: {
      setTitle(title) {
        this.customTitle = title
      }
    }
  }
</script>

<style lang="scss" scoped>
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    .loading-content {
      text-align: center;
      .desc {
        line-height: 20px;
        font-size: $font-size-small;
        color: $color-text-l;
      }
    }
  }
</style>
